import dynamic from 'next/dynamic';
import { ComponentProps } from './ReservationSummary.types';

export const ReservationSummary = dynamic<ComponentProps>(() => import('./ReservationSummary'));
// import('./ReservationSummary').then(module => module.ReservationSummary)
